import React from 'react';
import Header from './Header.jsx';
import Footer from './Footer.jsx';

export default function PageShell({ children, onProgramNavigate }) {
  return (
    <div className="page">
      <Header onProgramNavigate={onProgramNavigate} />
      <main>{children}</main>
      <Footer onProgramNavigate={onProgramNavigate} />
    </div>
  );
}
